// extracted by mini-css-extract-plugin
module.exports = {"approval":"Approval_approval__-ttae","headerContentWrap":"Approval_headerContentWrap__3o8gE","infoBlock":"Approval_infoBlock__3oeqw"};